// Teksty landingu — przeniesione z prototypu `b00k-landing.dc.html` bez przeredagowania.
// Sekcja kreatora rejestracji (7 kroków) pochodzi z promptu wdrożeniowego.

export const pl = {
  navCats: "Kategorie",
  navHow: "Jak to działa",
  navOps: "Dla operatorów",
  navPrice: "Cennik",
  navContact: "Kontakt",
  navBook: "Demo panelu operatora",
  pill: "Platforma rezerwacyjna dla operatorów usług",
  title1: "Twoje usługi.",
  title2: "Rezerwują się same.",
  sub: "b00k łączy kalendarze wszystkich Twoich usług — pokoi, aut, wizyt — w jeden system rezerwacyjny. Klienci rezerwują sami przez www i czat, a system pilnuje terminów i blokuje kolizje.",
  ctaBook: "Załóż konto operatora",
  ctaOperator: "Zobacz widok klienta",
  heroMeta: "TWOJA-FIRMA.B00K.ONLINE · KAŻDY OPERATOR MA WŁASNĄ SUBDOMENĘ",
  cardChip: "Potwierdzona",
  cardNote: "Rezerwacje spływają same — z www i czatu — i od razu blokują grafik.",
  catsKick: "KATEGORIE USŁUG",
  catsTitle: "Co obsłużysz na b00k",
  catsSub: "Jedna platforma dla wszystkich Twoich usług. Godzinowe wykonują się po kolei, pokoje i auta klienci rezerwują równolegle na dni.",
  cat1t: "Pokoje",
  cat1d: "Pokoje i apartamenty na jedną lub wiele nocy. Kilka pokoi rezerwujesz równolegle w tym samym terminie.",
  cat2t: "Samochody",
  cat2d: "Auta miejskie i SUV-y na doby. Kalendarz dostępności pilnuje zwrotów i wydań.",
  cat3t: "Atrakcje",
  cat3d: "Sauna, spa, kajaki. Rezerwacja na konkretną godzinę, z określonym czasem trwania.",
  cat4t: "Fryzjer",
  cat4d: "Strzyżenie i koloryzacja. Wybierasz godzinę — system blokuje dokładnie tyle czasu, ile trwa usługa.",
  cat5t: "Kosmetyka",
  cat5d: "Manicure i masaże. Łącz z innymi usługami — czasy zsumują się w jeden blok.",
  cat6t: "Medyczne",
  cat6d: "Konsultacje i badania na konkretną godzinę. Kalendarz gabinetu pilnuje się sam.",
  cat7t: "Warsztat",
  cat7d: "Naprawa samochodu, roweru czy laptopa — mamy to wszystko.",
  cat8t: "Korepetycje",
  cat8d: "Nauka języka czy grania na pianinie — obsłużysz to na naszej platformie.",
  cat9t: "Inne",
  cat9d: "Specyfika Twojej branży + nasze doświadczenie = sukces.",
  howKick: "JAK TO DZIAŁA",
  howTitle: "Trzy kroki, zero telefonów",
  s1t: "Dodaj usługi i zasoby",
  s1d: "Wpisz pokoje, auta i wizyty z czasem trwania i ceną. System weryfikuje poprawność danych każdego konta przy rejestracji — Twojego i klientów.",
  s2t: "Klienci rezerwują sami",
  s2d: "Przez www albo czat — WhatsApp i Messenger. Czasy usług się sumują, pokoje rezerwują się równolegle, a klient widzi tylko realnie wolne terminy.",
  s3t: "System pilnuje grafiku",
  s3d: "Z chwilą potwierdzenia termin jest zablokowany — dwie osoby nigdy nie zarezerwują tej samej usługi w tym samym czasie. Odwołania i przesunięcia też obsługuje system.",
  newChip: "Nowość",
  chatLine: "Twoi klienci założą rezerwację czatując — przez WhatsApp lub Messenger.",
  opsKick: "DLA OPERATORÓW",
  opsTitle: "Twój grafik pracuje dla Ciebie",
  opsSub: "Pokoje, auta i wizyty w jednym kalendarzu. Kolizje blokujemy automatycznie, rezerwacje z czatu spływają same, a Ty widzisz obłożenie i przychód na bieżąco.",
  opsCta: "Zobacz panel operatora",
  f1: "Kalendarz dnia i obłożenie zasobów w jednym widoku",
  f2: "Automatyczna blokada kolizji terminów",
  f3: "Rezerwacje z web i czatu — WhatsApp / Messenger",
  f4: "Klienci, notatki do rezerwacji i KPI",
  priceKick: "CENNIK",
  priceTitle: "Prosty jak rezerwacja",
  month: "mies.",
  recommended: "Polecany",
  soon: "DOSTĘPNE WKRÓTCE",
  custom: "Indywidualnie",
  opsSuffix: "pracowników",
  priceNote: "Cena miesięczna zależy od liczby pracowników z dostępem do panelu.",
  t1f1: "Kalendarz i rezerwacje przez www",
  t1f2: "Czat WhatsApp / Messenger",
  t1f3: "Klienci, notatki i przypomnienia",
  t2f1: "Wszystko z SOLO",
  t2f2: "Zasoby i usługi bez limitu",
  t2f3: "Raporty i wskaźniki obłożenia",
  t3f1: "Wszystko z TEAM",
  t3f2: "Grafiki i role pracowników",
  t3f3: "API i integracje",
  t4f1: "Wszystko z GROUP",
  t4f2: "Wsparcie wdrożeniowe i SLA",
  t4f3: "Umowa i rozliczenie indywidualne",
  conKick: "KONTAKT I DOJAZD",
  conTitle: "Twoja lokalizacja, ich dojazd",
  dirKick: "DOJAZD — TAK ZOBACZĄ GO KLIENCI",
  dir1: "Samochodem: droga krajowa nr 3 z Jeleniej Góry, zjazd Szklarska Poręba Centrum, dalej 5 minut ul. Zdrojową.",
  dir2: "Pociągiem: stacja Szklarska Poręba Górna, 12 minut pieszo w stronę centrum.",
  dir3: "Parking dla gości na miejscu — bez opłat, bez rezerwacji.",
  footUser: "Widok użytkownika",
  footOp: "Panel operatora",

  // ── Kreator rejestracji operatora (7 kroków) ──────────────────────────────
  wizTitle: "Załóż konto operatora",
  wizSub: "Siedem kroków. Po zakończeniu dostajesz własną subdomenę i gotowy panel.",
  wizStep1: "Dane firmy",
  wizStep2: "Subdomena",
  wizStep3: "Branże",
  wizStep4: "Plan",
  wizStep5: "Administrator",
  wizStep6: "Płatności",
  wizStep7: "Podsumowanie",
  wizNext: "Dalej",
  wizBack: "Wstecz",
  wizFinish: "Załóż konto",
  fCompany: "NAZWA FIRMY",
  fNip: "NIP",
  fPhone: "TELEFON",
  fAddress: "ADRES",
  fSlug: "SUBDOMENA",
  slugHint: "Adres, pod którym klienci zarezerwują u Ciebie usługi.",
  slugChecking: "Sprawdzamy dostępność…",
  slugFree: "Subdomena jest wolna.",
  slugTaken: "Ta subdomena jest już zajęta.",
  slugInvalid: "Subdomena: 3–63 znaki, małe litery, cyfry i myślnik (nie na początku ani końcu).",
  industriesHint: "Wybierz branże, które obsługujesz. Zawsze możesz dodać kolejne w panelu.",
  planHint: "Plan zmienisz w każdej chwili — bez utraty danych.",
  fName: "IMIĘ I NAZWISKO",
  fEmail: "E-MAIL",
  fPass: "HASŁO (MIN. 8 ZNAKÓW)",
  fPass2: "POWTÓRZ HASŁO",
  fTerms: "Akceptuję regulamin b00k.online i wyrażam zgodę na przetwarzanie danych w celu obsługi rezerwacji.",
  payTitle: "Płatności klientów",
  payHint: "Opcjonalne. Możesz przyjmować płatności online przy potwierdzaniu rezerwacji.",
  payEnable: "Przyjmuj płatności online",
  payMethods: "METODY PŁATNOŚCI",
  sumTitle: "Podsumowanie",
  sumCompany: "FIRMA",
  sumSub: "SUBDOMENA",
  sumIndustries: "BRANŻE",
  sumPlan: "PLAN",
  sumAdmin: "ADMINISTRATOR",
  sumPayments: "PŁATNOŚCI",
  yes: "Tak",
  no: "Nie",
  doneTitle: "Konto operatora gotowe",
  doneSub: "Twoja subdomena działa. Zaloguj się do panelu i dodaj usługi — rezerwacje ruszą od razu.",
  doneOpen: "Otwórz panel operatora",
  doneBooking: "Zobacz stronę rezerwacyjną",
  companyProofOk: "Zalogowano jako administrator firmy:",
  companyLoginOther: "Zaloguj się innym kontem",
  errGeneric: "Nie udało się założyć konta. Sprawdź dane i spróbuj ponownie.",
} as const;

export type Dict = Record<keyof typeof pl, string>;
